export default function () {
    this.user = Object.assign({}, this.$store.state.user)

    if (location.hash.includes('pagarme')) {
        this.currentTab = 1
    }
    this.loadData()
}
